"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugUI = void 0;
const vue_1 = require("vue");
const Card_1 = require("./card/Card");
const AllCards_1 = require("../cards/AllCards");
const GameModule_1 = require("../GameModule");
const ICardRenderDescription_1 = require("../cards/render/ICardRenderDescription");
const PreferencesManager_1 = require("./PreferencesManager");
const cards = new Map();
AllCards_1.ALL_CARD_MANIFESTS.forEach((manifest) => {
    const module = manifest.module;
    [
        manifest.projectCards,
        manifest.corporationCards,
        manifest.preludeCards,
        manifest.leaderCards,
        manifest.standardProjects
    ].forEach((deck) => {
        deck.factories.forEach((cf) => {
            const card = new cf.Factory();
            const cardNumber = card.metadata.cardNumber;
            cards.set(card.name, { card, module, cardNumber });
        });
    });
});
exports.DebugUI = vue_1.default.component('debug-ui', {
    components: {
        Card: Card_1.Card,
    },
    data: function () {
        return {
            filterText: '',
            filterDescription: false,
            sortById: false,
            base: true,
            corporateEra: true,
            prelude: true,
            venusNext: true,
            colonies: true,
            turmoil: true,
            community: true,
            ares: true,
            moon: true,
            leaders: true,
            promo: true,
            automaSoloVariant: true,
            preludeTwoExtension: true,
        };
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchString = urlParams.get('search');
        if (searchString) {
            this.filterText = searchString;
        }
    },
    watch: {
        filterText(newSearchString) {
            if (window.history.pushState) {
                const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?search=' + newSearchString;
                window.history.pushState({ path: newurl }, '', newurl);
            }
        },
    },
    methods: {
        toggleAll: function () {
            const data = this.$data;
            data.base = !data.base;
            data.corporateEra = !data.corporateEra;
            data.prelude = !data.prelude;
            data.venusNext = !data.venusNext;
            data.colonies = !data.colonies;
            data.turmoil = !data.turmoil;
            data.community = !data.community;
            data.promo = !data.promo;
            data.ares = !data.ares;
            data.moon = !data.moon;
            data.leaders = !data.leaders;
            data.automaSoloVariant = !data.automaSoloVariant;
            data.preludeTwoExtension = !data.preludeTwoExtension;
        },
        sort: function (names) {
            if (this.$data.sortById) {
                return [...names].sort((a, b) => {
                    var _a, _b;
                    const an = ((_a = cards.get(a)) === null || _a === void 0 ? void 0 : _a.cardNumber) || '';
                    const bn = ((_b = cards.get(b)) === null || _b === void 0 ? void 0 : _b.cardNumber) || '';
                    return an.localeCompare(bn);
                });
            }
            else {
                return [...names].sort();
            }
        },
        getAllStandardProjectCards: function () {
            return this.sort(AllCards_1.ALL_STANDARD_PROJECT_CARD_NAMES);
        },
        getAllProjectCards: function () {
            return this.sort(AllCards_1.ALL_PROJECT_CARD_NAMES);
        },
        getAllCorporationCards: function () {
            return this.sort(AllCards_1.ALL_CORPORATION_CARD_NAMES);
        },
        getAllPreludeCards: function () {
            return this.sort(AllCards_1.ALL_PRELUDE_CARD_NAMES);
        },
        getAllLeaderCards: function () {
            return this.sort(AllCards_1.ALL_LEADER_CARD_NAMES);
        },
        getAllTurmoilActionCards: function () {
            return this.sort(AllCards_1.ALL_TURMOIL_ACTION_CARD_NAMES);
        },
        filtered: function (cardName) {
            var _a;
            const card = cards.get(cardName);
            const filterText = this.$data.filterText.toUpperCase();
            if (this.$data.filterText.length > 0) {
                if (cardName.toUpperCase().includes(filterText) === false) {
                    if (this.$data.filterDescription) {
                        let desc = (_a = card === null || card === void 0 ? void 0 : card.card.metadata) === null || _a === void 0 ? void 0 : _a.description;
                        if (ICardRenderDescription_1.isIDescription(desc)) {
                            desc = desc.text;
                        }
                        if (desc === undefined || desc.toUpperCase().includes(filterText) === false) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
            }
            switch (card === null || card === void 0 ? void 0 : card.module) {
                case GameModule_1.GameModule.Base:
                    return this.base === true;
                case GameModule_1.GameModule.CorpEra:
                    return this.corporateEra === true;
                case GameModule_1.GameModule.Promo:
                    return this.promo === true;
                case GameModule_1.GameModule.Venus:
                    return this.venusNext === true;
                case GameModule_1.GameModule.Colonies:
                    return this.colonies === true;
                case GameModule_1.GameModule.Prelude:
                    return this.prelude === true;
                case GameModule_1.GameModule.Turmoil:
                    return this.turmoil === true;
                case GameModule_1.GameModule.Community:
                    return this.community === true;
                case GameModule_1.GameModule.Ares:
                    return this.ares === true;
                case GameModule_1.GameModule.Moon:
                    return this.moon === true;
                case GameModule_1.GameModule.Leader:
                    return this.leaders === true;
                case GameModule_1.GameModule.Automa:
                    return this.automaSoloVariant === true;
                case GameModule_1.GameModule.PreludeTwo:
                    return this.preludeTwoExtension === true;
                default:
                    return true;
            }
        },
        getLanguageCssClass() {
            const language = PreferencesManager_1.PreferencesManager.load('lang') || 'en';
            return 'language-' + language;
        },
    },
    template: `
        <div class="debug-ui-container" :class="getLanguageCssClass()">
            <h1>Cards List</h1>
            <div class="form-group">
              <input class="form-input form-input-line" placeholder="filter" v-model="filterText"></input>
              <input type="checkbox" name="filterDescription" id="filterDescription-checkbox" v-model="filterDescription"></input>
              <label for="filterDescription-checkbox">
                  <span v-i18n>Filter description</span>
              </label>
              <input type="checkbox" name="sortById" id="sortById-checkbox" v-model="sortById"></input>
              <label for="sortById-checkbox">
                  <span v-i18n>Sort by ID (work in progress)</span>
              </label>
            </div>

            <div class="create-game-page-column" style = "flex-flow: inherit; ">
            <button id="toggle-checkbox" v-on:click="toggleAll()">
                <span v-i18n>Toggle all</span>
            </button>

            <input type="checkbox" name="base" id="base-checkbox" v-model="base"></input>
              <label for="base-checkbox" class="expansion-button">
                  <span v-i18n>Base</span>
              </label>

              <input type="checkbox" name="corporateEra" id="corporateEra-checkbox" v-model="corporateEra"></input>
              <label for="corporateEra-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-CE"></div>
                  <span v-i18n>Corporate Era</span>
              </label>

              <input type="checkbox" name="prelude" id="prelude-checkbox" v-model="prelude"></input>
              <label for="prelude-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-prelude"></div>
                  <span v-i18n>Prelude</span>
              </label>

              <input type="checkbox" name="preludeTwoExtension" id="preludeTwoExtension-checkbox" v-model="preludeTwoExtension"></input>
              <label for="preludeTwoExtension-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-prelude-two"></div>
                  <span v-i18n>Prelude 2</span>
              </label>

              <input type="checkbox" name="venusNext" id="venusNext-checkbox" v-model="venusNext"></input>
              <label for="venusNext-checkbox" class="expansion-button">
              <div class="create-game-expansion-icon expansion-icon-venus"></div>
                  <span v-i18n>Venus Next</span>
              </label>

              <input type="checkbox" name="colonies" id="colonies-checkbox" v-model="colonies"></input>
              <label for="colonies-checkbox" class="expansion-button">
              <div class="create-game-expansion-icon expansion-icon-colony"></div>
                  <span v-i18n>Colonies</span>
              </label>

              <input type="checkbox" name="turmoil" id="turmoil-checkbox" v-model="turmoil"></input>
              <label for="turmoil-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-turmoil"></div>
                  <span v-i18n>Turmoil</span>
              </label>

              <input type="checkbox" name="promo" id="promo-checkbox" v-model="promo"></input>
              <label for="promo-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-promo"></div>
                  <span v-i18n>Promos</span>
              </label>

              <input type="checkbox" name="automaSoloVariant" id="automaSoloVariant-checkbox" v-model="automaSoloVariant"></input>
              <label for="automaSoloVariant-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-automa"></div>
                  <span v-i18n>Automa</span>
              </label>

              <input type="checkbox" name="ares" id="ares-checkbox" v-model="ares"></input>
              <label for="ares-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-ares"></div>
                  <span v-i18n>Ares</span>
              </label>

              <input type="checkbox" name="community" id="community-checkbox" v-model="community"></input>
              <label for="community-checkbox" class="expansion-button">
                  <div class="create-game-expansion-icon expansion-icon-community"></div>
                  <span v-i18n>Community</span>
              </label><span/>

              <input type="checkbox" name="moon" id="moon-checkbox" v-model="moon"></input>
              <label for="moon-checkbox" class="expansion-button">
                <div class="create-game-expansion-icon expansion-icon-themoon"></div>
                <span v-i18n>The Moon</span>
              </label><span/>

              <input type="checkbox" name="leaders" id="leaders-checkbox" v-model="leaders"></input>
              <label for="leaders-checkbox" class="expansion-button">
                <div class="create-game-expansion-icon expansion-icon-leaders"></div>
                <span v-i18n>CEOs</span>
              </label><span/>
            </div>

            <template v-if="this.leaders === true">
                <section class="debug-ui-cards-list">
                    <h2>CEO Cards</h2>
                    <div class="cardbox" v-for="card in getAllLeaderCards()">
                        <Card v-show="filtered(card)" :card="{'name': card}" />
                    </div>
                </section>
                <br>
            </template>

            <section class="debug-ui-cards-list">
                <h2>Project Cards</h2>
                <div class="cardbox" v-for="card in getAllProjectCards()">
                    <Card v-show="filtered(card)" :card="{'name': card}" />
                </div>
            </section>
            <br>
            <section class="debug-ui-cards-list">
                <h2>Corporations</h2>
                <div class="cardbox" v-for="card in getAllCorporationCards()">
                    <Card v-show="filtered(card)" :card="{'name': card}" />
                </div>
            </section>
            <br>
            <section class="debug-ui-cards-list">
                <h2>Preludes</h2>
                <div class="cardbox" v-for="card in getAllPreludeCards()">
                    <Card v-show="filtered(card)" :card="{'name': card}" />
                </div>
            </section>
            <br>
            <section class="debug-ui-cards-list">
              <h2>Standard Projects</h2>
              <div class="cardbox" v-for="card in getAllStandardProjectCards()">
                  <Card v-show="filtered(card)" :card="{'name': card}" />
              </div>
            </section>
            <br>
            <section class="debug-ui-cards-list">
              <h2>Turmoil Actions</h2>
              <div class="cardbox" v-for="card in getAllTurmoilActionCards()">
                  <Card v-show="filtered(card)" :card="{'name': card}" />
              </div>
            </section>
            <br>
            <br>
        </div>
    `,
});
//# sourceMappingURL=DebugUI.js.map